import { createFileRoute } from "@tanstack/react-router"
import { DonationPageDetailPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Action, Resource } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/finance/donations/pages/$pageUuid/"
)({
  component: function DonationPageDetailRoute() {
    return (
      <AuthorizationGate resource={Resource.DONATION} action={Action.READ}>
        <DonationPageDetailPage />
      </AuthorizationGate>
    )
  },
})
